class TdCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.hash = location.hash
  }
  connectedCallback() {
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.addEventListener(
      "click",
      this.upsellBannerButtonHandler.bind(this)
    );
    if(this.hash === "#cart-open") {
      this.open()
    }
  }

  upsellBannerButtonHandler(e) {
    if(!e.target.classList.contains('td-cart-drawer__upsell-button') && !e.target.closest('.td-cart-drawer__upsell-button')) return;
    this.upsellBannerButton = document.querySelector(
      ".td-cart-drawer__upsell-button"
    );
    const oldVariantId = parseInt(
      this.upsellBannerButton.getAttribute("data-old-variant")
    );
    const newVariantId = parseInt(
      this.upsellBannerButton.getAttribute("data-new-variant")
    );
    const variantQuantity = parseInt(this.upsellBannerButton.getAttribute("data-old-variant-qty"));

    
    if (oldVariantId > 0 && newVariantId > 0) {
      this.upsellBannerButton.classList.add("loading-upsell");
      // Add the new variant to the cart
      let addFormData = {
        'items': [
          {
            'id': newVariantId,
            'quantity': variantQuantity,
          },
        ],
      };

      let removeFormData = {
        updates: {
          [oldVariantId]: 0,
        },
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addFormData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to add the new variant to the cart");
          }
          return response.json();
        })
        .then((data) => {
          fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(removeFormData),
          })
            .then((removeResponse) => {
              if (!removeResponse.ok) {
                throw new Error(
                  "Failed to remove the old variant from the cart"
                );
              }
              return removeResponse.json();
            })
            .then((removeData) => {
              this.reRenderCart(newVariantId, variantQuantity);
              
            })
            .catch((removeError) => {
              console.error("Error removing the old variant:", removeError);
            });
        })
        .catch((addError) => {
          console.error("Error adding the new variant:", addError);
          this.upsellBannerButton.classList.remove("loading-upsell");
        });
    }
  }

  reRenderCart(productId, value) {
    const payload = {};
    payload.updates = {};
    payload.updates[productId] = value;
    payload.sections = this.getSectionsToRender().map((section) => section.id);
    return fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        this.renderContents(response);
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : this.querySelector("#TdCartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        if(this.querySelector(".drawer__inner-empty") || this.querySelector("#TdCartDrawer")) {
          if(focusElement) trapFocus(containerToTrapFocusOn, focusElement);
        }
        
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".td-cart-drawer").classList.contains("is-empty") &&
    this.querySelector(".td-cart-drawer").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      const bundle = document.getElementById("cart-bundle-input-drawer");
      if (!bundle) return;
      bundle.addEventListener("change", function (e) {
        if (this.checked) {
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              quantity: 1,
              id: document
                .getElementById("cart-bundle-input-drawer")
                .getAttribute("data-variant-id"),
            }),
          })
            .then((response) => {
              window.location.href = "/cart";
            })
            .catch((error) => {
              console.error("error:", error);
            });
        }
      });
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "td-cart-drawer",
        selector: "#TdCartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("td-cart-drawer", TdCartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "TdCartDrawer",
        section: "td-cart-drawer",
        selector: ".drawer__header",
      },
      {
        id: "TdCartDrawer",
        section: "td-cart-drawer",
        selector: ".drawer__content",
      },
      {
        id: "TdCartDrawer",
        section: "td-cart-drawer",
        selector: ".drawer__footer .cart-drawer__footer",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
